
import React from "react";

import { Header } from '../../Components/Layout/Header.jsx'

export class Info extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.showMenuFn(false);
    }

    render() {
        return <div>
            <Header key="header" {...this.state} {...this.props} detailsHeader="true" headerText="Tehnički preduvjeti" headerBackUrl={this.props.getHomePathFn(this.props.route.location)}></Header>

            <div id="page-wrapper" className="white padding-2p-on-mobile border-on-tablet margin-1p-on-tablet">
                <h1 className="margin-bottom mobile-hidden">Tehnički preduvjeti</h1>
                <div className="padding-sides-medium">
                    <div className="success-message text-left">
                        <span className="icon ico-check"></span>
                        <span>
                            Podržani OS: Android 5+, IOS 9+
                            </span>
                    </div>
                    <div className="success-message text-left">
                        <span className="icon ico-check"></span>
                        <span>
                            Upotreba JavaScripta: omogućena
                            </span>
                    </div>
                    <div className="success-message text-left">
                        <span className="icon ico-check"></span>
                        <span>
                            Upotreba SSL-a: omogućena
                            </span>
                    </div>
                    <div className="success-message text-left">
                        <span className="icon ico-check"></span>
                        <span>
                            Upotreba kolačića: omogućena
                            </span>
                    </div>
                </div>
            </div>
        </div>

    }
};
